"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSuvReplacingLuxurySedanRoute = exports.isCubaRoute = exports.isMexicanRoute = exports.isEnglishSpeakingCountryRoute = exports.isAsianRoute = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const isAsianRoute = (routeGeographyFlag) => routeGeographyFlag === legacy_enums_1.RouteGeographyFlag.isAsian;
exports.isAsianRoute = isAsianRoute;
const isEnglishSpeakingCountryRoute = (routeGeographyFlag) => routeGeographyFlag === legacy_enums_1.RouteGeographyFlag.isEnglishSpeaking;
exports.isEnglishSpeakingCountryRoute = isEnglishSpeakingCountryRoute;
const isMexicanRoute = (routeGeographyFlag) => routeGeographyFlag === legacy_enums_1.RouteGeographyFlag.isMexican;
exports.isMexicanRoute = isMexicanRoute;
const isCubaRoute = (routeGeographyFlag) => routeGeographyFlag === legacy_enums_1.RouteGeographyFlag.isCuba;
exports.isCubaRoute = isCubaRoute;
const isSuvReplacingLuxurySedanRoute = (routeGeographyFlag) => routeGeographyFlag === legacy_enums_1.RouteGeographyFlag.isSuvReplacingLuxurySedan;
exports.isSuvReplacingLuxurySedanRoute = isSuvReplacingLuxurySedanRoute;
//# sourceMappingURL=routeGeographyFlagUtils.js.map